import { Link } from 'react-router-dom';
import { SanitizeHTML } from '../globals/SanitizeHTML';

const PlacesResults = ({ items }) => {
  return (
    <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 md:gap-4 min-h-auto">
      {items.map((item) => {
        return (
          <li
            key={item.id}
            className="relative border-b border-gray-200 py-5 flex items-center space-x-3 focus:bg-primary md:border-0 md:rounded-2xl md:flex-col md:bg-white md:p-5"
          >
            <Link
              className="h-full flex items-center md:flex md:flex-col"
              to={(location) => {
                location.pathname.replace(location.pathname, '/');
                return {
                  location,
                  pathname: '/pages/map/' + item.id,
                };
              }}
            >
              <div className="h-full flex items-center md:flex md:flex-col">
                <div className="flex-shrink-0 md:mb-4 md:relative">
                  <img
                    className="rounded-full object-cover !h-12 !w-12 md:!h-20 md:!w-20"
                    src={item.acf.place_house_img}
                    alt={item.title.rendered}
                  />
                </div>
              </div>
              <h2 className="text-sm font-medium text-center pl-2 md:pl-0">
                <SanitizeHTML html={item.title.rendered} />
              </h2>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default PlacesResults;
